import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[dbOnFocus]'
})
export class OnFocusDirective {

  private el: ElementRef;
  constructor(private _el: ElementRef, public renderer: Renderer2) {
    this.el = this._el;
  }

  @HostListener('focus', ['$event']) onFocus(e) {
    this.renderer.addClass(this._el.nativeElement, 'fade');
    return;
  }
}
